import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { BasicInfoService } from 'src/app/services/basic-info.service';
import { Countries } from 'src/app/app.consts';
import { environment } from 'src/environments/local/environment';

@Injectable()
export class IdentificationGuard implements CanActivate {
  constructor(private basicInfo: BasicInfoService) {
  }

  canActivate(route: ActivatedRouteSnapshot, _: RouterStateSnapshot): boolean {
    const hasRequiredQueryParams = !!(route.queryParams.trxid && route.queryParams.ec && environment.country === Countries.NETHERLANDS);
    return hasRequiredQueryParams || this.basicInfo.canActivate();
  }
}
